import React, { ReactNode } from 'react';

import {
  initQueryClient,
  initRuntimeConfig,
  RuntimeConfigProvider,
} from '@hclinear/hc-linear-react';
import { BUILD_TIME_ENVIRONMENT, initHcLinearConfig, queryClient } from '@/configuration';
import { runtimeConfigSchema } from '@/validation/runtimeConfig.validation';
import { createAxiosAuthClient, createAxiosBackendClients } from '@/components';

interface AppConfigInitializerProps {
  children: ReactNode;
}

export const AppConfigInitializer = ({ children }: AppConfigInitializerProps) => {
  initQueryClient(queryClient as any);
  initRuntimeConfig({
    configPath: BUILD_TIME_ENVIRONMENT.RUNTIME_CONFIG_PATH,
    schema: runtimeConfigSchema,
  });

  return (
    <>
      <RuntimeConfigProvider>
        <AppConfigWithRuntimeConfig>{children}</AppConfigWithRuntimeConfig>
      </RuntimeConfigProvider>
    </>
  );
};

const AppConfigWithRuntimeConfig = ({ children }: AppConfigInitializerProps) => {
  initHcLinearConfig();
  createAxiosBackendClients();
  createAxiosAuthClient();
  return <>{children}</>;
};
